var STRING_TYPE = 'string';
var BOOLEAN_TYPE = 'boolean';
var OBJECT_TYPE = 'object';
var FUNCTION_TYPE = 'function';
function isType(v, t) {
    return typeof v === t;
}

function hiddenProperty(obj, props) {
    for (var key in props) {
        Object.defineProperty(obj, key, {
            enumerable: false,
            value: props[key],
        });
    }
}

var nativeGlobalThis = ( typeof globalThis === OBJECT_TYPE && globalThis
    || typeof window === OBJECT_TYPE && window
    || typeof global === OBJECT_TYPE && global
    || {});
var console = nativeGlobalThis.console;
var document$1 = nativeGlobalThis.document || {};
var location = nativeGlobalThis.location || {};
var navigator = (nativeGlobalThis.navigator || {});
var connection = navigator.connection;
var performance = nativeGlobalThis.performance;
var noop = function () { };
var perfNow = isType(performance && performance.now, FUNCTION_TYPE)
    ? function () { return performance.now(); }
    : Date.now;
var setTimeout$1 = nativeGlobalThis.setTimeout.bind(nativeGlobalThis);
var nextFrame = (nativeGlobalThis.requestAnimationFrame || setTimeout$1).bind(nativeGlobalThis);
var addEventListener = (nativeGlobalThis.addEventListener || noop).bind(nativeGlobalThis);

var nil = null;
var undef = undefined;
var DEFAULT_UNIT = 'ms';
function create(opts) {
    opts = opts || {};
    var idx;
    var cid = 0;
    var tmpEntry;
    var api;
    var now = opts.now || perfNow;
    var warn = opts.warn;
    var prefix = opts.prefix || '';
    var addons = opts.addons || [];
    var activeGroups = [];
    var notify = function (hook, entry, autoMeasurable) {
        idx = addons.length;
        while (idx--) {
            addons[idx][hook](entry, autoMeasurable);
        }
    };
    var createEntry = function (name, parent, timers, unit, isGroup, start, end, isolate, meta) {
        name = prefix + name;
        if (parent === api || isolate) {
            parent = !isolate && activeGroups[0] || nil;
        }
        if (timers[name]) {
            warn && warn("Timer '" + name + "' exists");
        }
        var autoMeasurable = start == nil;
        var entry = timers[name] = {
            id: ++cid,
            name: name,
            parent: parent,
            unit: unit || DEFAULT_UNIT,
            start: autoMeasurable ? now() : start,
            end: end != nil ? end : nil,
            meta: meta,
        };
        hiddenProperty(entry, {
            stop: function (time, meta) {
                if (time != nil && !(time >= 0)) {
                    meta = time;
                    time = undef;
                }
                entry.meta = entry.meta || meta;
                entry.end = time == nil ? now() : time;
                timers[name] = nil;
                if (isGroup) {
                    idx = activeGroups.length;
                    while (idx--) {
                        if (activeGroups[idx] === entry) {
                            activeGroups.splice(idx, 1);
                        }
                    }
                }
                notify('end', entry, autoMeasurable);
                return entry;
            },
        });
        if (parent) {
            if (parent.end !== nil && end == nil) {
                warn && warn("Timer '" + name + "' stopped");
            }
            else {
                entry.unit = parent.unit;
                // (parent as GroupEntry).active++;
                parent.entries.push(entry);
            }
        }
        function entryEnd(name, end, meta) {
            name = prefix + name; // mutation
            tmpEntry = timers[name];
            if (tmpEntry) {
                isType(tmpEntry.stop, FUNCTION_TYPE)
                    ? tmpEntry.stop(end, meta)
                    : warn && warn("Timer '" + name + "'.stop is not a func", { entry: tmpEntry });
            }
            else {
                warn && warn("Timer '" + name + "' not exists");
            }
        }
        if (isGroup) {
            // (entry as GroupEntry).active = 0;
            entry.entries = [];
            hiddenProperty(entry, {
                add: function (name, start, end, unit, meta) {
                    return createEntry(name, entry, timers, unit, 0, start, end).stop(end, meta);
                },
                time: function (name, start, unit) {
                    if (!(start >= 0)) {
                        unit = start;
                        start = undef;
                    }
                    return createEntry(name, entry, timers, unit, undef, start);
                },
                group: function (name, startOrIsolateOrUnit, isolateOrUnit, unit) {
                    if (isType(startOrIsolateOrUnit, BOOLEAN_TYPE)) {
                        unit = isolateOrUnit;
                        isolateOrUnit = startOrIsolateOrUnit;
                        startOrIsolateOrUnit = nil;
                    }
                    if (isType(startOrIsolateOrUnit, STRING_TYPE)) {
                        unit = startOrIsolateOrUnit;
                        startOrIsolateOrUnit = nil;
                        isolateOrUnit = 0;
                    }
                    if (isType(isolateOrUnit, STRING_TYPE)) {
                        unit = isolateOrUnit;
                    }
                    return createEntry(name, entry, timers, unit, 1, startOrIsolateOrUnit, nil, isolateOrUnit);
                },
                timeEnd: entryEnd,
                groupEnd: entryEnd,
            });
            !isolate && (cid > 1) && activeGroups.unshift(entry);
        }
        notify('start', entry, autoMeasurable);
        return entry;
    };
    api = createEntry(0, nil, Object.create(null), DEFAULT_UNIT, 1, 0, 0, 1);
    api.v = "2.0.0-rc.28";
    api.addons = addons;
    return api;
}

function domReady(fn) {
    if (document.readyState === 'complete') {
        setTimeout(fn, 0);
    }
    else {
        addEventListener('pageshow', fn);
    }
}

var promise;
var firstInput = function (callback) {
    try {
        if (!promise) {
            promise = new Promise(function (resolve) {
                ['keydown', 'mousedown', 'scroll', 'mousewheel', 'touchstart', 'pointerdown'].map(function (type) {
                    addEventListener(type, resolve, {
                        once: true,
                        passive: true,
                        capture: true,
                    });
                });
            });
        }
        promise.then(callback);
    }
    catch (_a) { }
};

var observe = function (type, handler) {
    var po;
    try {
        po = new PerformanceObserver(function (batch) {
            // console.log('🌀', type, batch.getEntries())
            batch.getEntries().map(handler);
        });
        po.observe({
            type: type,
            buffered: true,
        });
    }
    catch (_a) { }
    return po;
};
var disconnect = function (po) {
    po && po.disconnect();
};
var takeRecords = function (po, handler) {
    try {
        po && po.takeRecords().map(handler);
    }
    catch (_a) { }
};

var HIDDEN = 'hidden';
var visibilityState = 'visibilityState';
var inited = false;
var unloaded = false;
var firstTimeStamp = -1;
var hidden = function (handler, once) {
    if (!inited) {
        inited = true;
        addEventListener('pagehide', function (evt) {
            unloaded = !evt.persisted;
        });
        // https://bugs.chromium.org/p/chromium/issues/detail?id=987409
        addEventListener('beforeunload', noop);
    }
    addEventListener('visibilitychange', function (evt) {
        (document$1[visibilityState] === HIDDEN) && handler(evt.timeStamp, unloaded);
    }, {
        capture: true,
        once: !!once,
    });
};
if (document$1) {
    firstTimeStamp = document$1[visibilityState] === HIDDEN ? 0 : Infinity;
    hidden(function (ts) {
        firstTimeStamp = ts;
    }, true);
}
var firstHidden = function () { return firstTimeStamp; };

var create$1 = function (options) { return ({
    start: noop,
    end: function (entry) {
        if (!entry.parent) {
            print.call(options, entry);
        }
    },
}); };
function color(v, unit) {
    v = (unit === 'KB'
        ? v / 8
        : unit === 'fps'
            ? 70 - v
            : v);
    return 'color:#' + (v < 5 ? 'ccc' :
        v < 10 ? '666' :
            v < 25 ? '333' :
                v < 50 ? 'f90' :
                    v < 100 ? 'f60' :
                        'f00');
}
function print(entry) {
    var badge = this.badge;
    var unit = entry.unit;
    var dur = (entry.end - entry.start) / (unit === 'KB' ? 1024 : 1);
    var format = badge + entry.name + (unit === 'none' || !unit
        ? '%c'
        : ": %c" + (!unit || unit === 'raw' ? dur : dur.toFixed(3) + unit));
    var formatArgs = "font-weight:bold;" + color(dur, unit);
    if ('entries' in entry) {
        (console.groupCollapsed || console.group)(format, formatArgs);
        entry.entries.forEach(print, this);
        console.groupEnd();
    }
    else {
        console.log(format, formatArgs);
    }
}

var system = create({
    addons: /pk-print/.test(location) ? [create$1({ badge: '🔅' })] : [],
});
var send = function (groupName, start, end, nested, unit, meta) {
    nextFrame(function () {
        var group = system.group(groupName, start, unit);
        for (var key in nested) {
            if (nested.hasOwnProperty(key)) {
                var item = nested[key];
                group.add(key, item[0], item[1], item[2]);
            }
        }
        group.stop(end, meta);
    });
};

var _a;
// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/deviceMemory
var deviceMemory = navigator.deviceMemory;
// https://developer.mozilla.org/en-US/docs/Web/API/NavigatorConcurrentHardware/hardwareConcurrency
var hardwareConcurrency = performance.hardwareConcurrency;
var isHighEnd = hardwareConcurrency > 4 || deviceMemory > 4;
var isLowEnd = hardwareConcurrency <= 4 || deviceMemory <= 4;
var deviceType = (isHighEnd
    ? 'high'
    : isLowEnd
        ? 'low'
        : 'unk');
var experienceType = (isLowEnd || connection && (['slow-2g', '2g', '3g'].indexOf(connection.effectiveType) > -1
    || connection.saveData)) ? 'low' : 'high';
var nested = (_a = {},
    _a["type_" + deviceType] = [0, 1],
    _a["exp_" + experienceType] = [0, 1],
    _a);
deviceMemory && (nested.memory = [0, deviceMemory]);
hardwareConcurrency && (nested.hardware_concurrency = [0, hardwareConcurrency]);
send('pk-device', 0, 1, nested, 'raw');

var state = 0;
var check = function () {
    try {
        var _a = performance.getEntriesByType('navigation')[0], fetchStart = _a.fetchStart, domainLookupStart = _a.domainLookupStart, domainLookupEnd = _a.domainLookupEnd, requestStart = _a.requestStart, responseStart = _a.responseStart, responseEnd = _a.responseEnd, domComplete = _a.domComplete, domInteractive = _a.domInteractive, domContentLoadedEventEnd = _a.domContentLoadedEventEnd, loadEventEnd = _a.loadEventEnd;
        if (responseEnd && state === 0) {
            state = 1;
            send('pk-nav-net', fetchStart, responseEnd, {
                'dns': [domainLookupStart, domainLookupEnd],
                'tcp': [domainLookupEnd, requestStart],
                'request': [requestStart, responseStart],
                'response': [responseStart, responseEnd],
            });
        }
        if (domComplete && state === 1) {
            state = 2;
            send('pk-nav-dom-ready', responseEnd, domComplete, {
                'interactive': [responseEnd, domInteractive],
                'content-loaded': [domInteractive, domContentLoadedEventEnd],
                'complete': [domContentLoadedEventEnd, domComplete],
            });
        }
        if (loadEventEnd && state === 2) {
            state = 3;
            send('pk-nav-dom-load', responseEnd, loadEventEnd, {
                'ready': [responseEnd, domComplete],
                'load': [domComplete, loadEventEnd],
            });
        }
        if (state !== 3) {
            setTimeout$1(check, 250);
        }
    }
    catch (_b) { }
};
check();

var getVitalsScore = function (value, min, max) { return (value <= min
    ? 'good'
    : value <= max
        ? 'needs-improvement'
        : 'poor'); };

var ttb = 0;
var tti = 0;
var perf;
var handler = function (entry) {
    var _a, _b, _c;
    var startTime = entry.startTime;
    var value = entry.processingStart - startTime;
    if (startTime < firstHidden()) {
        // https://web.dev/fid/
        // 0-100     Green (good)
        // 100-300   Orange (needs improvement)
        // Over 300  Red (poor)
        value && send('pk-fid', 0, value, (_a = {
                value: [0, value]
            },
            _a["score_" + getVitalsScore(value, 100, 300)] = [0, value],
            _a));
        // https://web.dev/lighthouse-total-blocking-time/
        // https://nitropack.io/blog/post/what-is-total-blocking-time-tbt
        // 0-300     Green (good)
        // 300-600   Orange (needs improvement)
        // Over 600  Red (poor)
        ttb && send('pk-tbt', 0, ttb, (_b = {
                value: [0, ttb]
            },
            _b["score_" + getVitalsScore(ttb, 300, 600)] = [0, ttb],
            _b));
        // https://web.dev/interactive/
        // 0-3800     Green (good)
        // 3800-7300  Orange (needs improvement)
        // Over 7300  Red (poor)
        tti && send('pk-tti', 0, tti, (_c = {
                value: [0, tti]
            },
            _c["score_" + getVitalsScore(tti, 3800, 7300)] = [0, ttb],
            _c));
        disconnect(perf);
        disconnect(fid);
    }
};
var fid = observe('first-input', handler);
hidden(function () {
    takeRecords(fid, handler);
}, true);
var initPerf = function (fcpTime) {
    perf = observe('longtask', function (entry) {
        var startTime = entry.startTime;
        var duration = entry.duration;
        if (startTime > fcpTime && entry.name === 'self') {
            // The main thread is considered "blocked" any time there's a Long Task—a task
            // that runs on the main thread for more than 50 milliseconds (ms).
            var blocked = duration - 50;
            if (duration > 0) {
                ttb += blocked;
                tti = startTime + duration;
            }
        }
    });
};

// First Paint
var nested$1 = {};
var po = observe('paint', function (entry) {
    var name = entry.name;
    var time = entry.startTime;
    if (time < firstHidden()) {
        nested$1[name] = [0, time];
        if (name === 'first-contentful-paint') {
            // https://web.dev/first-contentful-paint/
            // FCP time (in seconds) | Color-coding      | FCP score (HTTP Archive percentile)
            // 0–2	                 | Green (fast)      | 75–100
            // 2–4                   | Orange (moderate) | 50–74
            // Over 4                | Red (slow)        | 0–49
            nested$1["score_" + getVitalsScore(time, 1000, 2500)] = [0, time];
            send('pk-paint', 0, time, nested$1);
            initPerf(time);
            disconnect(po);
        }
    }
});

var value = 0;
var resolved = false;
var handler$1 = function (entry) {
    var duration = entry.startTime;
    if (duration < firstHidden()) {
        value = duration;
    }
    else {
        finalization();
    }
};
var po$1 = observe('largest-contentful-paint', handler$1);
var finalization = function () {
    var _a;
    // https://web.dev/lcp/
    // 0-2.5   Green (good)
    // 2.5-4   Orange (needs improvement)
    // Over 4  Red (poor)
    !resolved && value && send('pk-lcp', 0, value, (_a = {
            value: [0, value]
        },
        _a["score_" + getVitalsScore(value, 2500, 4000)] = [0, value],
        _a));
    resolved = true;
    disconnect(po$1);
};
var resolve = function () {
    takeRecords(po$1, handler$1);
    finalization();
};
hidden(resolve, true);
firstInput(resolve);

var value$1 = 0;
var handler$2 = function (entry) {
    if (!entry.hadRecentInput) {
        value$1 += entry.value;
    }
};
var po$2 = observe('layout-shift', handler$2);
hidden(function (_, unloaded) {
    var _a;
    takeRecords(po$2, handler$2);
    if (unloaded && value$1) {
        // https://web.dev/cls/
        // 0-0.1      Green (good)
        // 0.1-0.25   Orange (needs improvement)
        // Over 0.25  Red (poor)
        send('pk-cls', 0, value$1, (_a = {
                value: [0, value$1]
            },
            _a["score_" + getVitalsScore(value$1, 0.1, 0.25)] = [0, value$1],
            _a));
    }
});

var conn = connection;
var check$1 = function () {
    var _a;
    send('pk-conn', 0, 1, (_a = {
            downlink: [0, conn.downlink],
            downlinkMax: [0, conn.downlinkMax],
            rtt: [0, conn.rtt]
        },
        // [`type_${conn!.type}`]: [0, 1],
        _a["save_data_" + conn.saveData] = [0, 1],
        _a["effective_type_" + (conn.effectiveType || 'unk')] = [0, 1],
        _a), 'raw');
};
try {
    if (conn) {
        check$1();
        conn.addEventListener('change', check$1);
    }
    else {
        send('pk-conn', 0, 1, { effective_type_unk: [0, 1] }, 'raw');
    }
}
catch (_a) { }

export { BOOLEAN_TYPE, FUNCTION_TYPE, OBJECT_TYPE, STRING_TYPE, addEventListener, connection, console, create, disconnect, document$1 as document, domReady, firstHidden, firstInput, hidden, hiddenProperty, isType, location, navigator, nextFrame, noop, observe, perfNow, performance, setTimeout$1 as setTimeout, system, send as systemSend, takeRecords };
